import React from 'react';
import { Icon } from './Icon.js';
export const IconBorderWidthFill18 = ({ ...props }) => {
    return (React.createElement(Icon, { size: "18px", ...props },
        React.createElement("path", { d: "M16.25,14H1.75c-.414,0-.75,.336-.75,.75s.336,.75,.75,.75h14.5c.414,0,.75-.336,.75-.75s-.336-.75-.75-.75Z", fill: "currentColor" }),
        React.createElement("rect", { x: "1", y: "9", width: "16", height: "3.5", rx: "1.25", ry: "1.25", fill: "currentColor", "data-color": "color-2" }),
        React.createElement("rect", { x: "1", y: "2", width: "16", height: "5.5", rx: "1.25", ry: "1.25", fill: "currentColor" })));
};
//# sourceMappingURL=IconBorderWidthFill18.js.map